import React from 'react';
import {Grid} from '@material-ui/core';
import PropTypes from 'prop-types';

const Section = ({title, children, className, id, itemClassName, itemId}) => {
  title = title ? <h1 className="title" dangerouslySetInnerHTML={ {__html: title}}/> : null;

  return (
      <Grid container className={`section${className ? ` ${className}` : ''}`} id={id}>
        <Grid item xs={12} className={`item${itemClassName ? ` ${itemClassName}` : ''}`} id={itemId}>
          {title}
          {children}
        </Grid>
      </Grid>
  );
};

Section.propTypes = {
  title: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  itemClassName: PropTypes.string,
  itemId:PropTypes.string,
  children: PropTypes.node,
};

Section.defaultProps = {
  title: '',
  className:'',
  itemClassName:'',
  children: '',
};

export default Section;